import { render, staticRenderFns } from "./NbSupervisorNavigationDrawer.vue?vue&type=template&id=0b126689"
import script from "./NbSupervisorNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NbSupervisorNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports